import React from 'react';
import styled from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';
import { Section, InnerSection } from '../../../styles/section/section';
import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { useTopicContext } from '../context';
import { sortArrayBasedonArrayOrder } from '../../../utils/sort-array-based-on-array-order';
import { Topics } from '../../../helpers/topics';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

const RelatedTopicSection = styled(Section)`
  min-height: 10rem;
  padding-top: 3.5rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    padding-top: 5rem;
  }
`;

const RelatedTopicInnerSection = styled(InnerSection)`
  padding-top: 2rem;
`;

export const RelatedTopics = () => {
  const data = useTopicContext() || {};
  const topics = data?.allStrapiTopic?.edges.filter(
    (x) => x.node?.topic_name?.toLowerCase() !== 'misc'
  );
  const sortedTopicIds = data?.getSupportData?.topics;
  const tempSortedTopics = sortArrayBasedonArrayOrder(topics, sortedTopicIds, (x) => x.node.id);
  const sortedTopics =
    tempSortedTopics && tempSortedTopics?.length > 0
      ? tempSortedTopics?.slice(0, 3)
      : topics?.slice(0, 3);
  const [ref] = SendInViewEvent({
    isLoading: data?.isLoading,
    component_name: 'topic_related_topics',
    data: {
      topics,
      sortedTopicIds,
      sortedTopics
    }
  });

  return (
    <RelatedTopicSection primary ref={ref}>
      <HeaderTextBlock>
        <HeaderTextBlockTitle>Related Topics</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <RelatedTopicInnerSection>
        <Topics topics={sortedTopics} />
      </RelatedTopicInnerSection>
    </RelatedTopicSection>
  );
};
